import { Skeleton } from "@/components/ui/skeleton";

/**
 * Loading skeleton for the single-project screen. Mirrors AppHeaderRail
 * (sidebar toggle + eyebrow/title/description) and the two-tab document/chat
 * switcher followed by a file-tree card.
 */
export function ProjectSkeleton() {
  return (
    <div className="min-h-screen">
      <header className="border-b bg-background">
        <div className="flex min-h-12 flex-wrap items-center gap-3 px-4 py-3 md:px-6">
          <Skeleton className="size-8 shrink-0 rounded-md" />
          <div className="min-w-0 flex-1">
            <Skeleton className="h-3 w-20" />
            <Skeleton className="mt-2 h-6 w-64" />
            <Skeleton className="mt-1 h-4 w-48" />
          </div>
        </div>
      </header>
      <div className="p-4 md:p-6">
        <div className="mb-4 flex rounded-md border bg-card p-1">
          <Skeleton className="h-9 w-28 rounded" />
          <Skeleton className="ml-1 h-9 w-28 rounded" />
        </div>
        <div className="rounded-md border bg-card">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="flex min-h-10 items-center gap-2 border-b px-2 last:border-b-0">
              <Skeleton className="size-4 rounded" />
              <Skeleton className="size-4 rounded" />
              <Skeleton className="size-4 rounded" />
              <Skeleton className="h-4 flex-1" />
              <Skeleton className="hidden h-3 w-12 sm:block" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
